"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _styledSystem = require("styled-system");

var _themeGet = require("@styled-system/theme-get");

var _Spinner = require("../Spinner");

var _BaseButton = require("./BaseButton");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const fillButtonVariants = (0, _styledSystem.variant)({
  key: 'buttonVariants.fill'
});
const fillButtonIconVariants = (0, _styledSystem.variant)({
  key: 'buttonIconVariants.fill'
});
const outlineButtonVariants = (0, _styledSystem.variant)({
  key: 'buttonVariants.outline'
});
const outlineButtonIconVariants = (0, _styledSystem.variant)({
  key: 'buttonIconVariants.outline'
}); // Until we get Icon converted to an emotion component, we'll need to rely on flameName

const isIconChild = child => child && child.type && child.type.flameName === 'Icon';

const isIconOnly = children => React.Children.count(children) === 1 && isIconChild(children);

const StyledSpinner = ( /*#__PURE__*/0, _styledBase.default)(_Spinner.Spinner, {
  target: "e1eugw0d0",
  label: "StyledSpinner"
})(props => props.fill && fillButtonIconVariants(props), ";", props => !props.fill && outlineButtonIconVariants(props), ";");
const ExtendedBaseButton = ( /*#__PURE__*/0, _styledBase.default)(_BaseButton.BaseButton, {
  target: "e1eugw0d1",
  label: "ExtendedBaseButton"
})("&:focus{outline:thin dotted;box-shadow:none;}svg{", props => props.isFillButton ? /*#__PURE__*/(0, _core.css)(fillButtonIconVariants(props), ";label:ExtendedBaseButton;") : /*#__PURE__*/(0, _core.css)(outlineButtonIconVariants(props), ";label:ExtendedBaseButton;"), ";}", props => props.isFillButton || props.variant === 'neutral' ? /*#__PURE__*/(0, _core.css)(fillButtonVariants(props), ";box-shadow:inset 0 1px 0 0 rgba(255,255,255,0.15);&.cr-button--hover,&.cr-button--active{", /*#__PURE__*/(0, _core.css)((0, _themeGet.themeGet)("buttonVariants.fill.".concat(props.variant, ".&:hover"))(props), ";label:ExtendedBaseButton;"), "}&.cr-button--active{", /*#__PURE__*/(0, _core.css)((0, _themeGet.themeGet)("buttonVariants.fill.".concat(props.variant, ".&:active"))(props), ";label:ExtendedBaseButton;"), "};label:ExtendedBaseButton;") : /*#__PURE__*/(0, _core.css)(outlineButtonVariants(props), ";&.cr-button--hover,&.cr-button--active{", /*#__PURE__*/(0, _core.css)((0, _themeGet.themeGet)("buttonVariants.outline.".concat(props.variant, ".&:hover"))(props), ";label:ExtendedBaseButton;"), "}&.cr-button--active{", /*#__PURE__*/(0, _core.css)((0, _themeGet.themeGet)("buttonVariants.outline.".concat(props.variant, ".&:active"))(props), ";label:ExtendedBaseButton;"), "};label:ExtendedBaseButton;"));

const loneIconAdjustments = (children, size) => {
  if (isIconOnly(children)) {
    switch (size) {
      case 'small':
        return {
          px: '0.4375rem',
          py: 0
        };

      case 'large':
        return {
          px: '0.6875rem',
          py: 0
        };

      case 'xlarge':
        return {
          px: '0.875rem',
          py: 0
        };

      default:
        return {
          px: '0.5625rem',
          py: 0
        };
    }
  }

  return {};
};

const remapChild = (child, size) => {
  // This is no bueno. We need to have additional logic
  // to handle buttons with a single Icon which have completely different styling.
  // We should probably extract this out into a seperate component instead as we're
  // adding a bit too much complexity on an already loaded component.
  if (isIconOnly(child)) {
    const clone = /*#__PURE__*/React.cloneElement(child, {
      size: child.props.size || size
    });
    return (0, _core.jsx)(ButtonContent, null, clone);
  }

  return (0, _core.jsx)(ButtonContent, null, child);
};

const SpinnerWrapper = ( /*#__PURE__*/0, _styledBase.default)('span', {
  target: "e1eugw0d2",
  label: "SpinnerWrapper"
})({
  name: "nmtq6q",
  styles: "display:flex;justify-content:center;position:absolute;left:0;right:0;"
});
const ButtonContent = ( /*#__PURE__*/0, _styledBase.default)('span', {
  target: "e1eugw0d3",
  label: "ButtonContent"
})({
  name: "18biwo",
  styles: "display:inline-flex;align-items:center;"
});
const ChildWrapper = ( /*#__PURE__*/0, _styledBase.default)('span', {
  target: "e1eugw0d4",
  label: "ChildWrapper"
})("opacity:", props => props.isLoading ? 0 : 1, ";display:inline-flex;", props => !props.noSpacing && /*#__PURE__*/(0, _core.css)(ButtonContent, ":not(:first-of-type){margin-left:0.5rem;};label:ChildWrapper;"), ";");

/**
 * Buttons are used to take action or confirm a decision. They help merchants get things done.
 */
const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let loading = _ref.loading,
      children = _ref.children,
      size = _ref.size,
      noSpacing = _ref.noSpacing,
      fill = _ref.fill,
      variant = _ref.variant,
      forcedState = _ref.forcedState,
      className = _ref.className,
      disabled = _ref.disabled,
      restProps = _objectWithoutProperties(_ref, ["loading", "children", "size", "noSpacing", "fill", "variant", "forcedState", "className", "disabled"]);

  const iconAdjustments = loneIconAdjustments(children, size);
  const nextChildren = React.Children.map(children, child => remapChild(child, size));
  const LinkifiedButton = restProps.href ? ExtendedBaseButton.withComponent('a', {
    target: "e1eugw0d5",
    label: "LinkifiedButton"
  }) : ExtendedBaseButton;
  const nextForceState = forcedState && "cr-button--".concat(forcedState);
  const isDisabled = loading || disabled; // TODO: Need to rework or split off the link buttons from the main component.
  // It causes some gnarly typing errors and overloads the component with even
  // more useless logic, since emotion supports the `as` prop anyways...

  return (// @ts-ignore
    (0, _core.jsx)(LinkifiedButton, _extends({
      ref: ref,
      isFillButton: fill,
      size: size,
      disabled: isDisabled,
      variant: variant === 'default' ? 'neutral' : variant,
      className: [className, nextForceState].join(' ')
    }, iconAdjustments, restProps), loading && (0, _core.jsx)(SpinnerWrapper, {
      title: "Loading..."
    }, (0, _core.jsx)(StyledSpinner, {
      fill: fill,
      variant: variant,
      size: size
    })), (0, _core.jsx)(ChildWrapper, {
      noSpacing: noSpacing,
      isLoading: loading
    }, nextChildren))
  );
});
exports.Button = Button;
Button.defaultProps = {
  size: 'medium',
  variant: 'neutral',
  block: false
};